import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../../shared";
import { CommissionReportContainerModel } from '../../../../../../models/aggregates/erp/commission-report';

@Injectable({providedIn: 'root'})
export class SalesCommissionReportService extends BaseApiTemplateService<CommissionReportContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.SALES_COMMISSION_PREFIX + 'backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.SALES_COMMISSION_PREFIX + 'backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.SALES_COMMISSION_PREFIX + 'backoffice-ep';
    this.httpClient = http;
  }
}
